<template>
  <div>
    <VRow v-if="edit" no-gutters>
      <VCol cols="9" md="10" class="pr-3">
        <AddressGeocodeInput
          v-model="address"
          :errors="errors.address"
          class="mb-2"
          @found="addressFoundHanlder"
          @not-found="addressNotFoundHanlder"
          @selected="saveAddress"
        />
      </VCol>
      <VCol cols="3" md="2">
        <VBtn
          text
          icon
          color="error"
          @click="cancel"
        >
          <VIcon>mdi-close</VIcon>
        </VBtn>
      </VCol>
    </VRow>
    <VRow v-else no-gutters>
      <VCol cols="9" md="10" class="pr-3">
        <VTextField
          class="mb-2"
          outlined
          dense
          hide-details
          type="text"
          readonly
          disabled
          autocomplete="off"
          :value="address.address"
        />
      </VCol>
      <VCol cols="3" md="2">
        <VBtn
          text
          icon
          color="success"
          @click="editAddress"
        >
          <VIcon>mdi-pencil-outline</VIcon>
        </VBtn>
        <VBtn
          text
          icon
          color="error"
          :loading="deleting"
          @click="destroyAddress"
        >
          <VIcon>mdi-delete</VIcon>
        </VBtn>
      </VCol>
    </VRow>
  </div>
</template>

<script>
import AddressGeocodeInput from './AddressGeocodeInput.vue';
import ValidationMixin from '../../mixins/ValidationMixin';
import Address from '../../orm/models/Address/Address';

export default {
  name: 'AddressInput',
  components: { AddressGeocodeInput },
  mixins: [ValidationMixin],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      address: { ...this.value },
      edit: !this.value.address,
      saving: false,
      deleting: false,
      errors: { address: [] },
    };
  },
  methods: {
    addressFoundHanlder() {
      this.errors = { address: [] };
    },
    addressNotFoundHanlder() {
      this.errors.address.push(this.$t('addressNotFound'));
    },
    editAddress() {
      this.edit = true;
    },
    async saveAddress() {
      await this.withApiErrorHandling(async () => {
        if (this.isNewAddress()) {
          const response = await Address.api().store(this.address);
          // eslint-disable-next-line prefer-destructuring
          this.address = response.entities.addresses[0];
          this.$emit('created', this.address);
        } else {
          await Address.api().update(this.value.id, this.address);
        }
        this.edit = false;
        this.$emit('input', this.address);
      }, (e) => {
        this.errors.address = [e.code === 422 ? this.$t('addressNotCorrect') : e.message];
      }, 'saving');
    },
    async destroyAddress() {
      try {
        await this.withLoading(async () => {
          await Address.api().destroy(this.value.id);
        }, 'deleting');
      } catch (e) {
        this.$toast.error(e.message);
      }
    },
    isNewAddress() {
      return String(this.value.id).startsWith('$uid');
    },
    cancel() {
      this.address = { ...this.value };
      this.edit = false;
      this.errors = { address: [] };
      this.$emit('cancel');
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  addressNotCorrect: Incorrect address
  addressNotFound: Address not found
</i18n>

<i18n locale="ru" lang="yaml">
  addressNotCorrect: Некорректный адрес
  addressNotFound: Указанный адрес не найден
</i18n>
